<template>
  <div class="drawer">
    <div class="right_drawer_btn" v-if="!isActive" style="right:0;" @click="clickBtn"><i class="catalog_logo"></i>目录</div>

    <!-- <div class="background" v-if="open" @click.self="isActive? clickBtn:closeDrop" > -->
        <div class="drop" @click.self="clickBtn" :class="isActive ? 'active':'close' ">
            <div class="right_drawer_btn" style="left:-30px;" v-if="isActive" @click="clickBtn"><i class="catalog_logo"></i>目录</div>
            <div class="drop_main">
                <div class="drop_main_title">课程目录</div>
                <div class="drop_main_conter">
                    <div class="drop_main_conter_list">
                      <!-- <div v-for="(val,key) in parentData" :key='key'>
                        <p :class="{'active_i_bg':val.lesson_id===lessonid}">
                            <i :class="{'active_i':val.lesson_id===lessonid}"></i>
                            课时{{key+1}}：{{val.lesson_name}}
                        </p>
                      </div> -->
                      <div v-for="(val,key) in parentData" :key='key'>
                        <p ref="p" @click="activeCourse($event,key)">
                            <i ref="i"></i>
                            课时{{key+1}}：{{val.lesson_name}}
                        </p>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: "Drawer",
  props:['parentData','lessonid'],
  data() {
    return {
      open: false,
      isActive: false
    };
  },
  methods: {
    clickBtn() {
      this.open = !this.open;
      this.isActive = !this.isActive;
    //   this.isActive? document.querySelector('.demand_main').style.animation='openpadding 0.3s normal forwards':document.querySelector('.demand_main').style.animation='closepadding 0.3s normal forwards'
      this.isActive? document.querySelector('.right_drawer_btn').style.left="-30px":document.querySelector('.right_drawer_btn').style.left="-30px"
    //   console.log(document.querySelector('.demand_main').style.paddingRight='300px')
    },
    activebg(d) {
      for(var i=0;i<d.length;i++){
        if(d[i].lesson_id==this.lessonid){
          this.$refs.p[i].className="active_i_bg";
          this.$refs.i[i].className="active_i";
        }
      }
    },
    activeCourse(e,key) {
      if(this.parentData[key].lesson_status_now == 0){
        this.$message('直播未开始')
      }else if(this.parentData[key].lesson_status_now == 2 || this.parentData[key].lesson_status_now == 1){
        this.$message('该课时回播正在上传中...')
      }else{
        var allP=document.querySelectorAll(".drop_main_conter_list p"),
        allI=document.querySelectorAll(".drop_main_conter_list p i");

        for(var i=0;i<allP.length;i++){
          if(allP[i].className==="active_i_bg"){
            allP[i].className='';
            allI[i].className='';
          }
        }
        e.target.className="active_i_bg";
        e.target.children[0].className="active_i";
        localStorage.setItem('lessonID',this.parentData[key].lesson_id);
        this.fileid(this.parentData[key]);
      }
    },
    fileid(lesson) {
       this.$emit('selectLesson', lesson)
      // this.$http.get('/api/v2/Lesson/getLesson',{
      //     headers:{
      //         'token': localStorage.getItem('token') !== null ? localStorage.getItem('token'):'',
      //     },
      //     params:{
      //         lesson_id: lesson_id,
      //     }
      // })
      // .then((res) => {
      //     if(res.data.code===1){
      //         // this.fileID=res.data.data.lesson_media_uri;
      //         this.$emit('getlessonID',res.data.data.lesson_media_uri)
      //     }else if(res.data.code===0){
      //         this.$message(res.data.msg);
      //     }
      // }).catch((err) => {
      //     console.log(err);
      // })
    },
    // closeDrop() {
    //   this.isActive = !this.isActive;
    //   setTimeout(() => {
    //     // this.open = false;
    //     this.open= !this.open;
    //   }, 200);
    //   document.querySelector('.demand_main').style.padding='0px'
    //   console.log(this.isActive,333333)
    // }
  },
  created() {

  },
  mounted() {
    this.activebg(this.parentData)
  }
};
</script>


<style scoped>
/* .drawer {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  background: #666;

} */
  .drop {
    /* width: 300px; */
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    background: #222222;
    color: #ffffff;
  }
  .active {
    animation: opendoor 0.3s normal forwards;
  }
  @keyframes opendoor {
    from {
      width: 0;
    }
    to {
      /* width: 100%; */
      width: 300px;
    }
  }
  .close {
    animation: close 0.3s normal forwards;
  }
  @keyframes close {
    0% {
      /* width: 100%; */
      width: 300px;
    }
    100% {
      width: 0;
      opacity: 0;
    }
  }
  /* .apadding {
    animation: openpadding 0.3s normal forwards;
  } */
  @keyframes openpadding {
    from {
      padding-right: 0;
    }
    to {
      /* width: 100%; */
      padding-right: 300px;
    }
  }
  /* .cpadding {
    animation: closepadding 0.3s normal forwards;
  } */
  @keyframes closepadding {
    0% {
      /* width: 100%; */
      padding-right: 300px;
    }
    100% {
      padding-right: 0;
    }
  }
  .oleft {
    animation: openleft 0.3s normal forwards;
  }
  @keyframes openleft {
    from {
      right: 0;
    }
    to {
      /* width: 100%; */
      right: 300px;
    }
  }
  .cleft {
    animation: closeleft 0.3s normal forwards;
  }
  @keyframes closeleft {
    0% {
      /* width: 100%; */
      right: 300px;
    }
    100% {
      right: 0;
    }
  }
.right_drawer_btn{
    cursor: pointer;
    text-align: center;
    color: #fff;
    width:30px;
    height:100px;
    background:#00C590;
    border-radius:10px 0px 0px 10px;
    position: absolute;
    top: 50%;
    box-sizing: border-box;
    padding: 20px 0;
    transform: translateY(-50%);
    /* right: 0; */
}
.drop_main{
  overflow: hidden;
}
.drop_main_title{
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 18px;
}
.drop_main_conter{
  height: 800px;
  overflow-y: auto;
}
.drop_main_conter_list div{
  cursor: pointer;
}
/* .drop_main_conter_list div:hover{
  color: #00C590;
} */
.drop_main_conter_list i{
    width: 12px;
    height: 14px;
    background: url('../assets/bofang.png') no-repeat 0 0;
    position: absolute;
    left: 24px;
    top: 50%;
    transform: translateY(-50%);
}
.active_i{
  background: url('../assets/bofang2.png') no-repeat 0 0 !important;
}
.active_i_bg{
  background:rgba(0,197,144,.3);
}
.drop_main_conter_list p{
    padding: 1em 24px 1em 47px;
    font-size: 14px;
    position: relative;
    margin: 0;
}
.catalog_logo{
  width: 20px;
  height: 20px;
  display: inline-block;
  background: url('../assets/catalog.png') no-repeat 0 0;
}
</style>







// WEBPACK FOOTER //
// src/components/drawer.vue